import React, { useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';

interface Props {
  elId: string;
}

export const AddressInputBackgroundLogo: React.FC<Props> = ({ elId }) => {
  const [focused, setFocused] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const inputEl = document.getElementById(elId) as HTMLInputElement;

    if (!inputEl) return;

    const onFocus = () => {
      setFocused(true);
    };
    const onBlur = () => {
      setFocused(false);
    };

    inputEl.addEventListener('focus', onFocus);
    inputEl.addEventListener('blur', onBlur);

    return () => {
      inputEl.removeEventListener('focus', onFocus);
      inputEl.removeEventListener('blur', onBlur);
    };
  }, [elId]);

  return (
    <Wrapper>
      <Svg
        width='639'
        height='816'
        viewBox='0 0 639 816'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g style={{ mixBlendMode: 'lighten' }}>
          <path
            d='M484.537 360.426L214.912 624.823C215.855 625.767 216.798 625.767 216.798 626.711C218.683 627.655 220.569 629.544 222.454 630.488C225.282 632.377 228.111 634.265 229.996 636.154C231.882 637.098 233.767 638.043 235.653 639.931C238.481 641.82 241.309 642.764 244.137 644.652C246.023 645.597 247.908 646.541 249.794 647.485C252.622 648.43 255.45 650.318 258.278 651.262C260.164 652.207 262.049 653.151 263.935 653.151C266.763 654.095 269.591 655.039 273.362 655.984C275.248 656.928 277.133 656.928 279.962 657.872C282.79 658.817 286.561 658.817 289.389 659.761C291.274 659.761 293.16 660.705 295.988 660.705C299.759 660.705 302.587 661.649 306.358 661.649C308.244 661.649 310.129 661.649 312.015 661.649C317.671 661.649 322.385 661.649 328.041 661.649C330.87 661.649 333.698 661.649 336.526 660.705H338.412H339.354C354.438 658.817 367.637 654.095 380.835 647.485C385.549 645.597 389.32 642.764 394.034 639.931C398.747 636.154 406.289 631.433 412.888 624.823L578.811 458.63C589.182 448.243 598.609 435.968 607.094 422.748L622.177 393.475C632.548 369.869 638.204 344.373 638.204 317.933C638.204 230.116 601.437 146.075 538.273 86.5862C474.167 26.1526 389.32 -5.00844 300.702 0.657208C139.493 9.15568 9.39405 143.243 2.79484 304.714C1.8521 323.599 5.62307 357.593 10.3368 385.921C13.165 381.2 15.9933 376.478 19.7642 371.757C20.707 370.813 21.6497 368.924 22.5925 367.98C25.4207 364.203 27.3062 361.37 30.1344 358.537C31.0772 357.593 32.0199 355.704 32.9626 354.76C36.7336 350.983 40.5046 346.262 44.2756 342.485L222.454 169.682C247.908 146.075 275.248 134.744 308.244 131.911C359.152 129.079 408.175 146.075 445.884 181.014L454.369 188.568C487.365 222.562 505.277 267.887 505.277 315.101C504.335 333.042 496.793 348.15 484.537 360.426Z'
            fill='url(#paint0_linear_1254_8334)'
          />
          <path
            d='M152.725 453.897L422.349 190.444C421.406 189.5 420.464 189.5 419.521 188.556C417.635 187.611 416.693 186.667 414.807 185.723C411.979 183.834 409.151 181.946 406.323 180.057C404.437 179.113 403.494 178.169 401.609 177.224C398.781 175.336 395.01 173.447 392.181 172.503C390.296 171.559 389.353 170.614 387.468 170.614C383.697 168.726 379.926 166.837 376.155 165.893C375.212 165.893 374.269 164.949 373.327 164.949C368.613 163.06 363.899 162.116 359.185 160.227C357.3 159.283 355.414 159.283 352.586 159.283C349.758 158.339 346.93 158.339 344.101 157.395C342.216 157.395 339.388 156.45 337.502 156.45C334.674 156.45 331.846 155.506 329.018 155.506C327.132 155.506 324.304 155.506 322.418 155.506C317.705 155.506 312.991 155.506 308.277 155.506C280.938 157.395 257.369 167.782 236.629 186.667L59.3929 358.525C51.8509 366.079 44.309 374.578 37.7098 383.076C31.1105 391.575 25.4541 401.017 20.7404 411.404L16.0266 421.791C5.65646 446.343 0 471.838 0 497.333C0 585.151 36.767 669.191 99.9308 728.681C164.037 789.114 248.884 820.275 337.502 814.61C497.769 804.223 628.81 670.136 634.467 508.665C635.409 489.779 631.638 454.841 626.925 427.457C625.982 428.401 625.039 430.29 624.096 431.234C614.669 445.398 604.299 458.618 592.043 469.95L518.509 544.547L426.12 637.086C417.635 644.64 410.094 650.306 404.437 654.083C385.582 667.303 363.899 675.801 341.273 678.634H338.445C335.617 678.634 331.846 679.578 329.018 679.578C325.247 679.578 321.476 679.578 316.762 679.578C315.819 679.578 313.934 679.578 312.991 679.578C310.163 679.578 308.277 679.578 305.449 679.578C301.678 679.578 298.85 678.634 295.079 678.634C292.251 678.634 290.365 677.69 287.537 677.69C283.766 676.746 280.938 676.746 277.167 675.801C274.338 674.857 272.453 674.857 269.625 673.913C265.854 672.969 263.026 672.024 259.255 671.08C257.369 670.136 254.541 669.191 252.655 669.191C248.884 668.247 246.056 666.359 242.285 665.414C240.4 664.47 237.571 663.526 235.686 662.582C231.915 660.693 229.087 658.804 225.316 656.916C223.43 655.972 221.545 655.027 219.659 654.083C215.888 652.194 213.06 649.362 209.289 647.473C207.404 646.529 206.461 645.585 204.575 643.696C199.862 639.919 195.148 636.142 190.434 631.42L181.95 623.866C148.954 589.872 131.041 544.547 131.041 497.333C133.87 482.225 140.469 466.172 152.725 453.897Z'
            fill='url(#paint1_linear_1254_8334)'
          />
        </g>
        <defs>
          <linearGradient
            id='paint0_linear_1254_8334'
            x1='307.379'
            y1='128.634'
            x2='316.046'
            y2='661.721'
            gradientUnits='userSpaceOnUse'
          >
            <stop
              offset='0.25'
              stopColor={focused ? theme.colors.primary.main : '#0D1013'}
              stopOpacity={focused ? 0.31 : 1}
              style={{ transition: 'all .4s' }}
            />
            <stop offset='0.677083' stopColor='#13161A' stopOpacity='0' />
          </linearGradient>
          <linearGradient
            id='paint1_linear_1254_8334'
            x1='395.5'
            y1='203'
            x2='355.891'
            y2='639.173'
            gradientUnits='userSpaceOnUse'
          >
            <stop
              stopColor={focused ? theme.colors.primary.main : '#0C0F13'}
              style={{ transition: 'all .4s' }}
              stopOpacity={focused ? 0.28 : 1}
            />
            <stop offset='0.671875' stopColor='#13161A' stopOpacity='0' />
          </linearGradient>
        </defs>
      </Svg>
    </Wrapper>
  );
};

const Svg = styled('svg')(({ theme }) => ({
  height: 667,
  width: 'auto',
  marginLeft: -40,
  [theme.min(theme.breakpoints.sm)]: {
    height: '40vw !important',
    maxHeight: 815,
    right: 0,
    left: 'auto',
    marginLeft: 0,
  },
}));

const Wrapper = styled('div')(({ theme }) => ({
  maxWidth: '100vw',
  overflow: 'hidden',
  position: 'absolute',
  top: 80,
  zIndex: -1,
  left: 0,
  right: 0,
  [theme.min(theme.breakpoints.sm)]: {
    right: '50%',
    transform: 'translateX(120%)',
    left: 'auto',
    maxWidth: 1520,
  },
}));
